import Config from "../config/";
import {
  encryptPayloadWithPublicKey,
  parsePublicKey
} from "./encryptionCore";

let cachedPublicKey = null;
let cachedPublicKeyPem = null;

function normalizePublicKey(pem) {
  return (pem || "").replace(/\\n/g, "\n").trim();
}

function getPublicKey() {
  const pem = normalizePublicKey(Config.payloadEncryptionPublicKey);
  if (!pem) {
    return null;
  }

  if (!cachedPublicKey || cachedPublicKeyPem !== pem) {
    cachedPublicKey = parsePublicKey(pem);
    cachedPublicKeyPem = pem;
  }

  return cachedPublicKey;
}

export function encryptPayload(text) {
  return encryptPayloadWithPublicKey(text, getPublicKey());
}
